import { render, staticRenderFns } from "./WalletTransfer.vue?vue&type=template&id=735b8858"
import script from "./WalletTransfer.vue?vue&type=script&lang=js"
export * from "./WalletTransfer.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports